import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./core/store";

import "bootstrap/dist/css/bootstrap.css";
import { Provider } from "react-redux";
import { setupAxiosInterceptors } from "./core/axios";
import "./index.css";

setupAxiosInterceptors();  //for Managing Headers
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <HashRouter basename={process.env.PUBLIC_URL}>
      <App />
    </HashRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
